/* eslint-disable camelcase */
import styled from '@emotion/styled';
import {Typography} from '@mui/material';
import { APP } from 'src/styles/variables';

export const MainWrapperDiv = styled('div')`
  overflow: auto;
  flex: 1;
`;

export const InfoDiv = styled('div')`
  display: flex;
`;

export const ColonSpan = styled('span')`
  padding: 0 0.5rem 0 0.5rem;
  font-weight: 600;
`;

export const SpaceSpan = styled('span')`
  width: 2rem;
`;

export const CardDiv = styled('div')<{
  isBorderRequired: boolean;
  component_type: string;
}>`
  margin: ${({component_type}) =>
    component_type !== 'document' ? '1em 1em 0.5em 1em' : ''};
  padding: 0.5rem;
  background-color: ${APP.PALETTE.COMMON.WHITE};
  box-shadow: none;
  border: ${({isBorderRequired}) =>
    isBorderRequired ? '1px solid #C8C8C8' : 'none'};
  border-radius: 10px;
`;

export const LabelTypography = styled(Typography)`
  font-size: 0.875rem;
`;

export const LoaderDiv = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
